/**
 * Bande de chips par site, pour affiner sans quitter le client déjà choisi.
 *
 * N'apparaît qu'à partir de 2 sites : avec un seul site, le filtre ne
 * distingue rien et n'encombrerait que l'écran.
 */
export interface OptionSite {
  readonly id: string;
  readonly name: string;
  readonly assetCount: number;
}

export function ChipsSite({
  sites,
  valeur,
  onChange,
}: {
  sites: readonly OptionSite[];
  valeur: string | null;
  onChange: (id: string | null) => void;
}) {
  if (sites.length < 2) return null;

  return (
    <div className="chips-site">
      <button
        type="button"
        className={`chip${valeur === null ? ' actif' : ''}`}
        onClick={() => onChange(null)}
      >
        Tous les sites
      </button>
      {sites.map((s) => (
        <button
          key={s.id}
          type="button"
          className={`chip${valeur === s.id ? ' actif' : ''}`}
          onClick={() => onChange(valeur === s.id ? null : s.id)}
        >
          {s.name} <span className="aide">{s.assetCount}</span>
        </button>
      ))}
    </div>
  );
}
